import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatPaginator } from '@angular/material';
import { Router } from '@angular/router';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';

@Component({
  selector: 'app-patient-current-encounters',
  templateUrl: './patient-current-encounters.component.html',
  styleUrls: ['./patient-current-encounters.component.css']
})
export class PatientCurrentEncountersComponent {
  displayedColumns: string[] = ['VisitDate','RenderingProvider','Status'];
  dataSource = new MatTableDataSource();
  status: string ="proceed";
  encounterType : number=0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
 constructor( public dialogRef: MatDialogRef<PatientCurrentEncountersComponent>,@Inject(MAT_DIALOG_DATA) public data: DialogData,private pastencountersService : ProgressNotesService,private router: Router) { 
     this.encounterType=data.notesType;
  this.getPastEncounters(data.notesType);
   }
 
   getPastEncounters(notesType : number)
   {
    this.pastencountersService.getInprogressNotes(CommonComponents.patientId,notesType,'Completed','').subscribe((pastEncounters: IEncounterData[]) =>
      {  
       this.dataSource.data=  pastEncounters;  
       this.dataSource.paginator = this.paginator;  
       });
   }

   Navigate(selectedRow : IEncounterData)
   {
    if(this.encounterType==1)  
       this.router.navigateByUrl('/Visitnote?encounterId=' + selectedRow.encounterId);  
    else if(this.encounterType==2)
         this.router.navigateByUrl('/ORNote?encounterId=' +selectedRow.encounterId);
      this.dialogRef.close();  
   }
   onNoClick(){
         this.dialogRef.close();
   }

}
export interface DialogData {
  notesType: number;
  headerText: string;
}